<template>
  <div class="sponsor-card">
    <div class="sponsor-card__grid">
      <div class="sponsor-card__grid__text" v-html="showInfoText"/>
      <div class="sponsor-card__grid__logos">
        <img :src="require(`@/assets/logos/${sponsorProps.img}.png`)"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "SponsorEuCard",
  props: {
    artistName: {
      type: String,
      required: false,
      default: undefined
    },
    showName: {
      type: String,
      required: true
    },
    sponsor: {
        type: String,
        required: true,
        description: 'Accept:  sounds-now | ulysses'
      }
  },
  computed: {
    showInfoText() {
      if (this.showName !== undefined && this.artistName !== undefined) {
        if (this.showName.toLowerCase().trim() === this.artistName.toLowerCase().trim()) { // Show name === Artist name
          return `${this.showName} ${this.sponsorText}`;
        } if (this.sponsor === 'eu') {
          return this.sponsorText;
        } else {
          return `${this.showName} by <strong>${this.artistName}</strong> ${this.sponsorText}`;
        }
      } else if (this.artistName === undefined){
          return `${this.showName} ${this.sponsorText}`;
      } else {
        return `This show ${this.sponsorText}`;
      }
    },
      sponsorProps(){
          let sponsor = {};
          switch (this.sponsor) {
              case 'sounds-now':
                  sponsor.label = 'Sounds Now';
                  sponsor.img = 'sounds-now';
                  break;
              case 'ulysses':
                  sponsor.label = 'Ulysses european odyssey',
                  sponsor.img = 'ulysses'
                  break;
              case 'eu':
                  sponsor.label = 'Ulysses european odyssey',
                  sponsor.img = 'eu'
                  break;
          }
          return sponsor;
      },
    sponsorText() {
      if (this.sponsor === 'eu') {
        return `Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union or European Education and Culture Executive Agency. Neither the European Union nor the granting authority can be held responsible for them.`
      } else {
        return `is realized within the framework of the ${this.sponsorProps.label} project, co-funded by the Creative Europe Programme of the European Union`;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/abstracts/_variables.scss";

.sponsor-card {
  &__grid {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px 0;
    @include media-breakpoint-down(md) {
      display: block;
    }

    &__text, &__logos {
      flex: 0 1 calc(50% - 10px);
    }

    &__text {
      @include font-10();
      @include media-breakpoint-down(md) {
        line-height: 1.2em;
        margin-bottom: 10px;
      }
      @include media-breakpoint-up(xxxl) {
        flex: 0 0 33.333%;
        padding-right: 10px;
      }
    }

    &__logos {
      @include media-breakpoint-up(xxxl) {
        flex: 0 0 33.333%;
      }
    }
  }

}
</style>
